import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const signIn: any = createAsyncThunk<any>(
	'login',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.post(`auth/sign-in`, data, {
				headers: {
					devicetype: 'DESKTOP'
				}
			});
			return response;
		} catch (err: any) {
			return rejectWithValue(err.response);
		}
	}
);

export const logoutAction: any = createAsyncThunk<any>(
	'logoutAction',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.put(`auth/logout`, data);
			return response;
		} catch (err: any) {
			return rejectWithValue(err.response);
		}
	}
);

export const verifing: any = createAsyncThunk<any>(
	'verifing',
	async (data: any) => {
		const response = await httpService.post(`auth/verify-user`, data);
		return response;
	}
);

export const forgotPassword: any = createAsyncThunk<any>(
	'forgotPassword',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post(
				`auth/forgot-password`,
				data
			);
			return response;
		} catch (err: any) {
			return rejectWithValue(err?.response);
		}
	}
);

export const resendOTP: any = createAsyncThunk<any>(
	'resendOTP',
	async (data: any) => {
		const response: any = await httpService.post(`auth/resend-otp`, data);
		return response;
	}
);

export const verifingOTP: any = createAsyncThunk<any>(
	'verifingOTP',
	async (data: any) => {
		const response = await httpService.post(
			`auth/verify-mobile-forgot-password-otp`,
			data
		);
		return response;
	}
);

export const checkResetPasswordLink: any = createAsyncThunk<any>(
	'checkResetPasswordLink',
	async (data) => {
		const response = await httpService.post(
			`auth/check-rest-password-link`,
			data
		);
		return response;
	}
);

export const changePassword: any = createAsyncThunk<any>(
	'changePassword',
	async (data: any) => {
		const response = await httpService.post(
			`auth/change-password-with-token`,
			data
		);
		return response;
	}
);

export const getCountry: any = createAsyncThunk<any>('getCountry', async () => {
	const response = await httpService.get(`common/get-countries`);
	return response;
});

export const roleAccessed: any = createAsyncThunk<any>(
	'roleAccessed',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post(
				`auth/user-role-accessed`,
				data
			);
			return response;
		} catch (err: any) {
			return rejectWithValue(err.response.data);
		}
	}
);

export const getUserRoles: any = createAsyncThunk<any>(
	'getUserRoles',
	async (data) => {
		const response = await httpService.get(`auth/user-roles`, {
			params: data
		});
		return response.data;
	}
);
//for token valid time update
export const getTokenInfo: any = createAsyncThunk<any>(
	'getTokenInfo',
	async () => {
		const response = await httpService.get(`/auth/token-validity`);
		return response.data;
	}
);
export const updateTokenValidationTime: any = createAsyncThunk<any>(
	'updateTokenValidationTime',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.put(
				`/auth/token-validity`,
				data
			);
			return response.data;
		} catch (err: any) {
			return rejectWithValue(err.response?.data);
		}
	}
);
